import React, { useRef, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/Formal.jpg";
import Tilt from "react-parallax-tilt";
import { AiFillGithub, AiFillMail } from "react-icons/ai";
import emailjs from "emailjs-com";
import { FaLinkedinIn, FaHackerrank } from "react-icons/fa";
import { SiLeetcode } from "react-icons/si";
import Image from "react-bootstrap/Image";
import Toast from "../Toast/Toast.js";

function Home2() {
  const form = useRef();
  const [showToast, setShowToast] = useState(false);
  const [loading, setLoading] = useState(false); // New loading state

  const sendEmail = (e) => {
    e.preventDefault();
    setLoading(true); // Start loader

    emailjs
      .sendForm(
        "service_xp2swci",
        "template_ycz8jxd",
        form.current,
        "HGa6KUC-URnrSCRuk"
      )
      .then(
        (result) => {
          // console.log("*(*(*(*", result.status);
          if (result?.status === 200 || 201) {
            setShowToast(true);
            setTimeout(() => setShowToast(false), 3000); // Auto-hide after 3 seconds
          }
        },
        (error) => {
          console.error(error.text);
        }
      )
      .finally(() => {
        setLoading(false); // Stop loader
      });

    e.target.reset();
  };

  return (
    <Container fluid className="home-about-section" id="about">
      {showToast && (
        <Toast
          message="Email sent successfully!"
          onClose={() => setShowToast(false)}
        />
      )}
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I fell in love with programming and I have at least learnt
              something, I think… 🤷‍♂️
              <br />
              <br />I am fluent in classics like
              <i>
                <b className="purple"> Java, Javascript and Python. </b>
              </i>
              <br />
              <br />
              My field of Interest's are building new &nbsp;
              <i>
                <b className="purple">Web Technologies and Products </b> and
                also in areas related to{" "}
                <b className="purple">
                  Data Science and Artificial Intelligence
                </b>
              </i>
              <br />
              <br />
              Whenever possible, I also apply my passion for developing products
              with <b className="purple">Java, Node.js</b> and
              <i>
                <b className="purple">
                  {" "}
                  Modern Javascript Library and Frameworks
                </b>
              </i>
              &nbsp; like
              <i>
                <b className="purple"> React.js</b>
              </i>
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <Image
                src={myImg}
                className="img-fluid"
                alt="avatar"
                roundedCircle="true"
              />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>

            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/NeazMorshed180031"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.hackerrank.com/neazmorshed_sd?hr_r=1"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaHackerrank />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://leetcode.com/neazmorshedsd/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <SiLeetcode />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/neazmorshedsd/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://mail.google.com/mail/?view=cm&fs=1&to=neazmorshed180031@gmail.com.com"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillMail />
                </a>
              </li>
              <div className="mt-2 bg-transparent">
                <form
                  ref={form}
                  onSubmit={sendEmail}
                  className="d-flex flex-column gap-2"
                >
                  <input
                    className="border rounded border-secondary bg-transparent p-4 text-white "
                    type="text"
                    name="name"
                    placeholder="Full Name"
                    required
                  />
                  <input
                    className="border rounded border-secondary bg-transparent p-4 text-white"
                    type="email"
                    name="email"
                    placeholder="Your Email"
                    required
                  />
                  <textarea
                    className="border rounded border-secondary bg-transparent p-4 text-white "
                    name="message"
                    rows="7"
                    placeholder="Type your message"
                    required
                  ></textarea>
                  <button type="submit" className="btn btn-primary">
                    {loading ? "Sending..." : "Send Message"}{" "}
                    {/* Loader text */}
                  </button>
                </form>
              </div>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Home2;
